import Button from 'components/Button/Button';
import React, { useState } from 'react';
import styled from 'styled-components';
import { alertErrorMessage, alertSuccessMessage } from 'utils/alerts';
import { programaticallyDownloadFileFromHref } from 'utils/utils';
import DownloadAssetsModal from './DownloadAssetsModal';
import { createDownloadJob, getDownloadJobStatus } from 'api/assets.api';
import { ErrorResponseDto } from 'api/config/ErrorResponseDto';
import { DownloadJobStatusResponse, DownloadStatusEnum } from 'types/asset';

const StyledButtonContainer = styled.div`
  margin-right: 10px;
`;

type DownloadAssetsProps = {
  disabled: boolean
}

export const DownloadAssets = (props: DownloadAssetsProps) => {
  const [modalOpen, setModalOpen] = useState(false);

  function handleFileStatus(res: DownloadJobStatusResponse, interval: NodeJS.Timeout) {
    switch (res.status) {
      case DownloadStatusEnum.processing:
        break;

      case DownloadStatusEnum.export_succeeded:
        clearInterval(interval);
        programaticallyDownloadFileFromHref(res.url);
        setModalOpen(false);
        alertSuccessMessage('File has been downloaded successfully');
        break;

      case DownloadStatusEnum.failed:
        handleError()
        break;
    }
  }

  function handleError(err: string = "") {
    console.log(err);
    setModalOpen(false);
    alertErrorMessage('Error downloading file');
  }

  function handleExport() {
    setModalOpen(true);
    createDownloadJob()
      .then(res => {
        const interval = setInterval(() => {
          getDownloadJobStatus(res.job_id)
            .then((res) => handleFileStatus(res, interval))
            .catch((error: ErrorResponseDto) => {
              clearInterval(interval);
              handleError(error.errorMsg);
            });
        }, 1000);
      })
      .catch((error: ErrorResponseDto) => handleError(error.errorMsg));
  }

  return (
    <StyledButtonContainer>
      <Button
        id='download-button'
        style={{ width: '170px' }}
        outline
        onClick={handleExport}
        disabled={props.disabled}
      >
        Download Assets
      </Button>
      {modalOpen && <DownloadAssetsModal />}
    </StyledButtonContainer>
  );
}
